<template>
    <div class="main">
        <Header></Header>
        <div class="page-body wrap">
            <router-view v-if="isRouterAlive" />
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
    import Header from '../main/header'
    import Footer from '../main/footer'
    export default {
        name: 'ProMain',
        components: {
            Header,
            Footer
        },
        provide () {
            return {
                reload: this.reload
            }
        },
        data () {
            return {
                isRouterAlive: true
            }
        },
        methods: {
            reload () {
                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            }
        }
    }
</script>

<style scoped>
    .page-body{
        padding-top: 20px;
        padding-bottom: 84px;
    }
</style>
